import { Mic } from 'lucide-react';
import { MemberMessageMarkdown, type Density } from './ProvenanceAssistantMessage';

interface ProvenanceMemberBubbleProps {
  text: string;
  density: Density;
  pending?: boolean;
}

export function ProvenanceMemberBubble({ text, density, pending = false }: ProvenanceMemberBubbleProps) {
  const bubblePaddingClass = density === 'comfortable' ? 'py-2.5' : 'py-2';
  return (
    <div
      data-testid={pending ? 'voice-pending-bubble' : 'speak2me-member-message'}
      className={`w-full rounded-lg bg-primary px-3 ${bubblePaddingClass} text-sm text-primary-foreground${pending ? ' opacity-70' : ''}`}
    >
      {pending ? (
        <div className="flex justify-end">
          <Mic className="h-3 w-3 animate-pulse text-primary-foreground/80" />
        </div>
      ) : null}
      <MemberMessageMarkdown text={text} density={density} />
    </div>
  );
}
